import { Component, OnInit, ElementRef, Renderer, HostListener  } from '@angular/core';
import { MatDialogConfig, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { CountrymapComponent } from '../countrymap/countrymap.component';
import { GlobalsService } from '../services/globals.service';
import { QuotationDetail } from '../services/domain.service';
import { Router } from '@angular/router';
import { DataService } from '../services/data.service';
import { StudentType } from '../services/enums.service';
import { SnotifyService, SnotifyPosition } from 'ng-snotify';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.less']
})
export class DefaultComponent implements OnInit {

  constructor(private elRef: ElementRef,
    private renderer: Renderer,
    private dialog: MatDialog,
    private globals: GlobalsService,
    private router: Router,
    private data: DataService,
    private notifier: SnotifyService) { }

  ngOnInit() {
    this.data.changePage("home");
    this.initialiseQuotationDetail();

    if(this.globals.quotationDetail) {
      this.globals.quotationDetail = undefined;
    }
  }

  ngAfterViewInit(){
    this.checkBrowser();
  }

  async checkBrowser(){
    await this.delay(500); 

    var isIE = /*@cc_on!@*/false || !!document.documentMode;
    if(isIE){
      alert('We have noticed that you are using Internet Explorer. For optimal UWC Online Quotation experience, we suggest using the following browsers: Chrome, Firefox, Edge, Safari, Opera');
    }
  }

  private delay(ms: number)
  {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  initialiseQuotationDetail(){
    let quotationDetail: QuotationDetail = { studentType: StudentType.local, academicYear: 0, degreeTypeId: "",    degreeTypeName: "", 
    gradTypeId: "", gradTypeName: "", studyTypeId: "", studyTypeName: "", facultyId: "", facultyName: "", programmeId: 0, 
    programmeName: "", streamId: "", streamName: "", yearLevelId: 0, yearLevelName: "", quotationsModules: [], programmeDuration: 0, chargeByModule: true, programmeCost: 0,
    includeRes: false, generateQuotation: false, generateProforma: false, residence: undefined, personalInfo: undefined, proformaInfo: undefined };

    this.globals.quotationDetail = quotationDetail;
  }

  showMap(mapId: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = mapId;

    let dialogRef = this.dialog.open(CountrymapComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      //Remove focus on the selected button clicked
      this.renderer.invokeElementMethod(this.elRef.nativeElement, 'blur', []);
    });
  }

  proceed(sType: number) {
    let quotationDetail: QuotationDetail = { studentType: sType, academicYear: 0, degreeTypeId: "",    degreeTypeName: "", 
    gradTypeId: "", gradTypeName: "", studyTypeId: "", studyTypeName: "", facultyId: "", facultyName: "", programmeId: 0, 
    programmeName: "", streamId: "", streamName: "", yearLevelId: 0, yearLevelName: "", quotationsModules: [], programmeDuration: 0, chargeByModule: true, programmeCost: 0,
    includeRes: false, generateQuotation: false, generateProforma: false, residence: undefined, personalInfo: undefined, proformaInfo: undefined };

    this.globals.quotationDetail = quotationDetail;
    this.router.navigate(['/default', {outlets: {'main': ['disclaimer']}}]);
  }
}

declare global {
  interface Document{
    documentMode?: any;
  }
}
